export const opacity = Object.freeze({
  sm: '24%',
  disabled: '50%',
  inactive: '62%',
} as const);
